import { jsxs as e, jsx as i } from "react/jsx-runtime";
import s from "react";
import { styled as n } from "styled-components";
import { RangoBrand as m } from "./Brand.js";
import { e as f } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { RangoProfileButton as h } from "./ProfileButton.js";
import { RangoButtonIconHighlight as p, ButtonIconHighlightSize as u } from "./ButtonIconHighlight.js";
const w = n.div.withConfig({
  displayName: "Container",
  componentId: "sc-1ga5net-0"
})(["display:flex;flex-flow:column nowrap;min-height:100vh;width:var(--size-35x);background-color:var(--elements-bg-color-01);border-right:var(--border-width-xs) solid var(--elements-border-color);box-sizing:border-box;"]), x = n.div.withConfig({
  displayName: "ChildrenContainer",
  componentId: "sc-1ga5net-1"
})(["width:100%;"]), C = n.div.withConfig({
  displayName: "LogoContainer",
  componentId: "sc-1ga5net-2"
})(["height:var(--size-15x);display:flex;flex-flow:row nowrap;align-items:center;flex-shrink:0;padding:0px var(--spacing-3x);"]), b = n.span.withConfig({
  displayName: "BrandName",
  componentId: "sc-1ga5net-3"
})(["", ";width:100%;color:var(--color-green-600);overflow:hidden;"], f), v = n(m).withConfig({
  displayName: "BrandLogo",
  componentId: "sc-1ga5net-4"
})(["height:var(--size-5x);padding-right:var(--spacing-1_5x);"]), N = n.div.withConfig({
  displayName: "LoggedContainer",
  componentId: "sc-1ga5net-5"
})(["display:flex;flex-flow:column nowrap;gap:var(--spacing-2x);height:auto;margin-top:auto;padding:var(--spacing-3x);background:var(--elements-bg-color-01);"]), y = n(h).withConfig({
  displayName: "ProfileButton",
  componentId: "sc-1ga5net-6"
})(["width:100%;span{justify-content:space-between;}"]), B = s.forwardRef(({
  children: a,
  showLogged: t = !0,
  showNotificationButton: r = !0,
  brandProps: d,
  onButtonNotificationClick: l,
  onProfileButtonClick: c,
  ...o
}, g) => /* @__PURE__ */ e(w, { ref: g, "data-testid": "rango-side-menu", "data-rango-component": "rango-side-menu", "data-is-rango": !0, ...o, children: [
  /* @__PURE__ */ e(C, { children: [
    /* @__PURE__ */ i(v, { ...d }),
    /* @__PURE__ */ i(b, { children: o.productName })
  ] }),
  /* @__PURE__ */ i(x, { children: a }),
  t && /* @__PURE__ */ e(N, { children: [
    r && /* @__PURE__ */ i(p, { "aria-label": o.notificationAriaLabel, icon: "NotificationLine", showNotification: o.showNotification, size: u.SM, onClick: l }),
    /* @__PURE__ */ i(y, { label: o.label, description: o.description, onClick: c, "aria-label": o.userProfileButtonAriaLabel })
  ] })
] }));
B.displayName = "RangoSideMenu";
export {
  B as RangoSideMenu
};
